module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-stepper', {
    staticStyle: {
      "background-color": "transparent"
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1"
    }
  }, [_vm._v("Name of step 1")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2"
    }
  }, [_vm._v("Name of step 2")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Name of step 3")])], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "padding": "0px",
      "height": "500px"
    },
    attrs: {
      "step": "1"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)"
    }
  }, [_c('font', {
    attrs: {
      "face": "verdana"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v("Schedule")])])], 1)]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "450px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0001.jpg"
    }
  })])])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "grey",
    attrs: {
      "href": _vm.schedulePDF,
      "target": "_blank",
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    }
  }, [_c('v-icon', [_vm._v("cloud_download")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "2"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0002.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "3"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0003.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 4
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "4"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0004.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 5
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "5"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0005.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 6
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 4
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "6"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0006.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 7
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 5
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "7"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0007.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 8
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 6
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "8"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0008.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 9
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 7
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "9"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0009.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 10
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 8
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "10"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0010.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 11
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 9
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "11"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0011.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 12
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 10
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "12"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0012.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 13
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 11
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "13"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0013.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 14
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 12
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "14"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0014.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 13
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-473560ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/amartithi-schedule.vue
// module id = 305
// module chunks = 1